var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHaha(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 27,
    r: 18,
    style: {
      fill: "#79deee",
      stroke: "#104e58",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.68,22.33c-2.58-2.25-6.55-1.7-8.43,1.16l-.22,.33,.82,.84,.47-.29c2.04-1.26,4.5-1.62,6.81-1.01l.55-1.03Z",
    style: {
      fill: "#104e58"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.68,22.06l-.32,.24,.5,1.07c2.5-.59,5.14-.12,7.29,1.29l.85-.79c-1.66-3-5.57-3.84-8.32-1.8Z",
    style: {
      fill: "#104e58"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29,16.08c1.11-.07,3.66,.25,5,2.12",
    style: {
      fill: "none",
      stroke: "#104e58",
      strokeLinecap: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,16.08c-1.11-.07-3.66,.25-5,2.12",
    style: {
      fill: "none",
      stroke: "#104e58",
      strokeLinecap: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.59,29.5H15.41c-.69,0-1.18,.68-.93,1.32,1.2,3.16,3.56,7.68,9.53,7.68s8.33-4.52,9.53-7.68c.24-.64-.24-1.32-.93-1.32Z",
    style: {
      fill: "#13707e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.01,33.5c-3.89,0-6.88,1.8-4.87,3.5,1.03,.87,2.86,1.53,4.87,1.5,1.51-.02,3.49-.44,4.87-1.5,1.95-1.5-.97-3.5-4.87-3.5Z",
    style: {
      fill: "#aef0fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.43,28H15.57c-1.67,0-2.95,1.66-2.33,3.31,1.34,3.52,4.09,8.69,10.76,8.69s9.42-5.17,10.76-8.69c.63-1.65-.65-3.31-2.33-3.31Zm-8.43,10c-5.3,0-7.6-3.99-8.89-7.4-.1-.26,.09-.6,.46-.6h16.86c.37,0,.56,.34,.46,.6-1.29,3.41-3.59,7.4-8.89,7.4Z",
    style: {
      fill: "#104e58"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHaha);
export default __webpack_public_path__ + "static/media/haha.43ea98d23523d0b79bab2f3b724ffc6e.svg";
export { ForwardRef as ReactComponent };